const Icon = (props: any) => {
    return (
        <svg width={12} height={16} viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M6.656 1H2.062c-.348 0-.681.147-.928.41a1.449 1.449 0 00-.384.99v11.2c0 .371.138.727.384.99.247.262.58.41.928.41h7.875c.348 0 .682-.148.928-.41.246-.263.384-.619.384-.99V5.9L6.656 1z"
                stroke="currentColor"
                strokeWidth={1.225}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.656 1v4.9h4.594"
                stroke="currentColor"
                strokeWidth={1.225}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Icon;
